
import { defineComponent } from 'vue'
import { getLang } from '@/hooks/lang'

export default defineComponent({
  props: {
    credibilityValue: {
      type: Number,
      default: -1,
    },
  },
  setup() {
    const lang = getLang()
    return {
      lang,
    }
  },
})
